/* First-level discovery and links to existing product-specific size guides. */
document.addEventListener('DOMContentLoaded',()=>{
  const menu=document.querySelector('[data-nav-menu-panel]');
  const groups=[...menu.querySelectorAll('.nav-menu__group')];
  groups.forEach(group=>group.addEventListener('toggle',()=>{if(group.open)groups.forEach(other=>{if(other!==group)other.open=false;});}));
  menu?.querySelectorAll('a[href]').forEach(link=>{
    const url=new URL(link.href,location.origin);
    if(url.origin===location.origin&&url.pathname.replace(/\/$/,'')===location.pathname.replace(/\/$/,'')){
      link.setAttribute('aria-current','page');
    }
  });
  const help=document.querySelector('[data-fit-help]');if(!help)return;
  let returnFocus;
  const open=trigger=>{
    const productGuide=document.querySelector('[data-product-root] [data-size-guide-open]');
    if(productGuide){productGuide.click();return;}
    returnFocus=trigger;help.hidden=false;document.body.classList.add('ft-fit-help-open');
    help.querySelector('header button').focus({preventScroll:true});
  };
  const close=()=>{help.hidden=true;document.body.classList.remove('ft-fit-help-open');
    const target=returnFocus?.closest('[aria-hidden="true"]')?document.querySelector('[data-nav-menu-mobile-open]'):returnFocus;
    if(target?.getClientRects().length)target.focus({preventScroll:true});else{const fallback=[document.querySelector('[data-nav-menu-mobile-open]'),document.querySelector('[data-nav-menu-open]')].find(el=>el?.getClientRects().length);fallback?.focus({preventScroll:true});}
  };
  document.querySelectorAll('[data-fit-help-open]').forEach(button=>button.addEventListener('click',()=>open(button)));
  help.querySelectorAll('[data-fit-help-close]').forEach(button=>button.addEventListener('click',close));
  help.addEventListener('keydown',event=>{
    if(event.key==='Escape'){event.preventDefault();close();return;}
    if(event.key!=='Tab')return;
    const nodes=[...help.querySelectorAll('a,button,[tabindex="0"]')].filter(el=>el.tabIndex>=0&&!el.disabled&&el.getClientRects().length);
    const first=nodes[0],last=nodes.at(-1);
    if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
    else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
  });
  document.addEventListener('focusin',event=>{if(!help.hidden&&!help.contains(event.target))help.querySelector('header button').focus({preventScroll:true});});
  const url=new URL(location.href);
  if(url.searchParams.get('fitouch_guide')==='1'){
    url.searchParams.delete('fitouch_guide');history.replaceState(history.state,'',url);
    open(document.querySelector('[data-product-root] [data-size-guide-open]'));
  }
});
